import React, { createContext, useEffect, useState } from "react";

export const ServiceSearchQueryContext = createContext();

export const ServiceSearchQueryProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // Debounce search query to prevent frequent updates
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the delay (500ms) as needed

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  // Reset currentPage when debouncedSearchQuery changes
  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearchQuery]);

  return (
    <ServiceSearchQueryContext.Provider
      value={{
        searchQuery,
        setSearchQuery,
        debouncedSearchQuery,
        currentPage,
        setCurrentPage,
      }}
    >
      {children}
    </ServiceSearchQueryContext.Provider>
  );
};
